import type { IAPIConfig } from "../api";
import { getBaseAPIUrl } from "../api";

export const advertisingConfig = {
  baseURL: getBaseAPIUrl("advertising"),
} as IAPIConfig;
